var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCopy(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "#808085",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 4C2 2.89543 2.89543 2 4 2H11C12.1046 2 13 2.89543 13 4V11C13 12.1046 12.1046 13 11 13H4C2.89543 13 2 12.1046 2 11V4ZM4 3.5H11C11.2761 3.5 11.5 3.72386 11.5 4V11C11.5 11.2761 11.2761 11.5 11 11.5H4C3.72386 11.5 3.5 11.2761 3.5 11V4C3.5 3.72386 3.72386 3.5 4 3.5Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.25 7C14.8358 7 14.5 7.33579 14.5 7.75C14.5 8.16421 14.8358 8.5 15.25 8.5C15.9404 8.5 16.5 9.05964 16.5 9.75V15.25C16.5 15.9404 15.9404 16.5 15.25 16.5H9.75C9.05964 16.5 8.5 15.9404 8.5 15.25C8.5 14.8358 8.16421 14.5 7.75 14.5C7.33579 14.5 7 14.8358 7 15.25C7 16.7688 8.23122 18 9.75 18H15.25C16.7688 18 18 16.7688 18 15.25V9.75C18 8.23122 16.7688 7 15.25 7Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.7428add0.svg";
export { ForwardRef as ReactComponent };